import { RootState } from "@app/redux/root-reducer";

export const selectTestimonialsState = (state: RootState) =>
  (state as any)?.testimonials?.testimonials || {};

export const selectTestimonialDetailState = (state: RootState) =>
  (state as any)?.testimonials?.testimonialDetail || {};

export const selectAddTestimonialState = (state: RootState) =>
  (state as any)?.testimonials?.addTestimonial || {};

export const selectUpdateTestimonialState = (state: RootState) =>
  (state as any)?.testimonials?.updateTestimonial || {};

export const selectDeleteTestimonialState = (state: RootState) =>
  (state as any)?.testimonials?.deleteTestimonial || {};
